import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './Field.scss'

function Field({ label, htmlFor, children, className }) {
  const componentClass = cx(style.field, { [className]: className })

  const componentLabel = typeof label === 'string' ? <label htmlFor={htmlFor}>{label}</label> : label
  return (
    <div className={componentClass}>
      {componentLabel}
      {children}
    </div>
  )
}

Field.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  htmlFor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
}

export default Field



// WEBPACK FOOTER //
// ./src/components/Common/Field.js